jQuery(function ($){

  $(".slide").on('click', function () {
    var elementClick = '#'+$(this).attr("href").split("#")[1]
    var destination = $(elementClick).offset().top - 90;
    jQuery("html:not(:animated),body:not(:animated)").animate({scrollTop: destination}, 1200);
    return false;
  });

});